class AvailableTimeRequest {
  static createEvent = {
    start: "",
    end: "",
    title: "",
    allDay: ""
  };
  static createAvailableTimeGroup = {
    availableTimeGroupProfessionalId: null,
    availableTimeGroupDayOfWeek: null,
    availableTimeGroupStartTime: null,
    availableTimeGroupEndTime: null
  };
  static readByProfessionalId = {
    professionalId: null
  };

  static readCount = {
    professionalId: null
  };

  static readDates = {
    professionalId: null
  };

  static readByDate = {
    professionalId: null,
    date: null
  };

  static readNextDays = {
    professionalId: null
  };

  static readByAvailableTimeGroupId = {
    availableTimeGroupId: null
  };
  static delete = {
    availableTimeGroupId: null,
    availableTimeGroupProfessionalId: null
  };
  static readSubscriptionTime = {
    professionalId: null,
    daysOfWeek: null,
    subscriptionType: null
  };
}

export default AvailableTimeRequest;
